import { useCallback, useEffect, useState } from 'react';
import { safeStorage } from '@/app/utils/client';

// 存储键名常量
const PWA_SHOWN_KEY = 'VIDU_PWA_PROMPT_SHOWN';
const VIDEO_GENERATION_KEY = 'VIDU_VIDEO_GENERATION_FOR_PWA_INSTALL';
const MAX_COUNT = 6;

export const usePWACount = () => {
  const [hasShown, setHasShown] = useState(false);
  const [currentCount, setCurrentCount] = useState(0);

  useEffect(() => {
    // 检查是否已经展示过PWA安装提示
    const hasShownBefore = safeStorage.getItem(PWA_SHOWN_KEY) === 'true';
    setHasShown(hasShownBefore);

    // 获取当前计数
    const videoGenerationCount = safeStorage.getItem(VIDEO_GENERATION_KEY);
    const generationCount = videoGenerationCount ? Number.parseInt(videoGenerationCount, 10) : 0;
    setCurrentCount(generationCount);
  }, []);

  // 增加计数的方法
  const incrementPWAInstallCount = useCallback(() => {
    // 如果已经显示过弹窗，就不再增加计数
    if (hasShown) {
      return;
    }

    const newCount = currentCount + 1;
    setCurrentCount(newCount);
    safeStorage.setItem(VIDEO_GENERATION_KEY, newCount.toString());
  }, [currentCount, hasShown]);

  // 标记已经展示过弹窗
  const markAsShown = useCallback(() => {
    setHasShown(true);
    safeStorage.setItem(PWA_SHOWN_KEY, 'true');
  }, []);

  // 检查是否应该显示PWA安装提示
  const shouldShowPWAPrompt = useCallback(() => {
    return !hasShown && currentCount >= MAX_COUNT;
  }, [hasShown, currentCount]);

  return {
    currentCount,
    hasShown,
    incrementPWAInstallCount,
    markAsShown,
    shouldShowPWAPrompt,
  };
};
